import Api from './api';

const ContratoService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/contrato/listar',
            params: params
        })
        return response
    },
    todos: async () => {
        const response = await Api({
            method: 'get',
            url: '/contrato/todos'
        })
        return response
    },
    chamamento: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/contrato/chamamento',
            params: params
        })
        return response
    },
    numContrato: async (params) => {
        return Api({
            method: 'get',
            url: '/contrato/numcontrato',
            params: params
        })
    },
    modalidade: async (params) => {
        return Api({
            method: 'get',
            url: '/contrato/modalidade',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/contrato/buscar?${params}`)
        return response
    }
}

export default ContratoService;